export const HEADER_HEIGHT = 80;
